import {
  List,
  Datagrid,
  TextField,
  ReferenceField,
  ReferenceInput,
  AutocompleteInput,
  useCreate,
  SaveButton,
  SimpleForm,
  Toolbar,
  useRefresh,
  useNotify,
  useRecordContext,
  EditButton,
} from 'react-admin'
import { Box, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import { useFormContext } from 'react-hook-form'

const AssignBookToolbar = () => {
  const [create] = useCreate()
  const refresh = useRefresh()
  const notify = useNotify()

  const { id } = useParams()
  const { getValues } = useFormContext()

  const onSubmit = async e => {
    e.preventDefault()

    const { bookId } = getValues()
    const playlistId = parseInt(id)

    create(
      'playlist-contents',
      {
        data: {
          playlistId,
          entityId: bookId,
          entityType: 'books',
        },
      },
      {
        onSuccess: () => {
          refresh()
          notify('Book assigned successfully')
        },
        onError: error => {
          notify(`${error.message}`, { type: 'error' })
        },
      },
    )
  }

  return (
    <Toolbar>
      <SaveButton type="button" onClick={onSubmit} />
    </Toolbar>
  )
}

const AssignBookAside = () => {
  return (
    <Box sx={{ margin: '0.5rem', width: 400 }}>
      <SimpleForm toolbar={<AssignBookToolbar />}>
        <ReferenceInput label="Assign Book" source="bookId" reference="books">
          <AutocompleteInput
            optionText="title"
            variant="standard"
            filterToQuery={searchText => ({
              title: { $iLike: `%${searchText}%` },
            })}
          />
        </ReferenceInput>
      </SimpleForm>
    </Box>
  )
}

const PlaylistBooksTab = () => {
  const record = useRecordContext()
  const playlistId = record?.id

  return (
    <>
      {!playlistId && (
        <Typography variant="body1">
          You must save the playlist information first before updating the book
          list!
        </Typography>
      )}
      {playlistId && (
        <List
          sx={{ width: '100%' }}
          disableSyncWithLocation
          actions={null}
          resource="playlist-contents"
          basePath="/playlist-contents"
          aside={<AssignBookAside />}
          filter={{
            playlistId: playlistId,
            entityType: 'books',
          }}>
          <Datagrid rowClick={false}>
            <TextField source="id" label="ID" />
            <ReferenceField source="entityId" reference="books" label="Book">
              <TextField source="title" />
            </ReferenceField>
            <EditButton basePath="/playlist-contents" />
          </Datagrid>
        </List>
      )}
    </>
  )
}

export default PlaylistBooksTab
